import { Fragment, useEffect } from "react";
import "./DsMap.mudule.css";
import SearchIcon from "@mui/icons-material/Search";
import { Box, IconButton, InputAdornment, TextField } from "@mui/material";

let map;

function KakaoMap(props) {
  const new_script = (src) => {
    return new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.src = src;
      script.addEventListener("load", () => {
        resolve();
      });
      script.addEventListener("error", (e) => {
        reject(e);
      });
      document.head.appendChild(script);
    });
  };

  const containerId = props.containerId || "mapcntr";
  const mapId = props.mapId || "dsmap";

  useEffect(() => {
    const el = document.getElementById(containerId);
    const mapEl = document.getElementById(mapId);
    if (el && mapEl) {
      mapEl.style.width = el.clientWidth + "px";
    }
  }, [containerId, mapId]);

  useEffect(() => {
    //카카오맵 스크립트 읽어오기
    const my_script = new_script(
      'https://dapi.kakao.com/v2/maps/sdk.js?appkey=b7967dc1f2c2b6f788a029bc7b701f09&libraries=services,clusterer,drawing"'
    );
    //스크립트 읽기 완료 후 카카오맵 설정
    my_script.then(() => {
      const kakao = window["kakao"];
      kakao.maps.load(() => {
        const mapContainer = document.getElementById(mapId);
        const options = {
          center: new kakao.maps.LatLng(37.884878, 127.729656), //좌표설정
          level: 3,
        };
        map = new kakao.maps.Map(mapContainer, options); //맵생성
        //지도종류 선택
        const mapTypeControl = new kakao.maps.MapTypeControl();
        map.addControl(mapTypeControl, kakao.maps.ControlPosition.TOPRIGHT);
        //스카이뷰를 기본값으로 설정
        map.setMapTypeId(kakao.maps.MapTypeId.HYBRID);

        //마커설정
        const markerPosition = new kakao.maps.LatLng(37.884878, 127.729656);
        const marker = new kakao.maps.Marker({
          position: markerPosition,
        });
        marker.setMap(map);

        window.kakao.maps.event.addListener(map, "click", (mouseEvent) => {
          // 클릭한 위치의 좌표를 가져옵니다.
          const latlng = mouseEvent.latLng;
          let lat = latlng.getLat().toFixed(6);
          let lon = latlng.getLng().toFixed(6);
          let addr = "";

          //클릭한 위치의 주소를 가져옵니다.
          const geocoder = new kakao.maps.services.Geocoder();
          geocoder.coord2Address(
            latlng.getLng(),
            latlng.getLat(),
            (result, status) => {
              if (status === kakao.maps.services.Status.OK) {
                addr = result[0].address.address_name.replace(
                  "강원특별자치도 ",
                  ""
                );
                props.clickedvalue(lat, lon, addr);
              } else {
                props.clickedvalue(lat, lon, "주소없음");
              }
            }
          );
          marker.setPosition(latlng);
        });

        // 주소검색 기능 수정
        const ps = new kakao.maps.services.Places();

        // 검색 결과 처리 함수
        function placesSearchCB(data, status, pagination) {
          if (status === kakao.maps.services.Status.OK) {
            // 첫 번째 검색 결과의 좌표로 이동
            const firstResult = data[0];
            const moveLatLon = new kakao.maps.LatLng(
              firstResult.y,
              firstResult.x
            );

            // 지도 중심을 이동
            map.setCenter(moveLatLon);

            // 마커 위치 업데이트
            marker.setPosition(moveLatLon);

            // 좌표 정보 업데이트
            const lat = firstResult.y;
            const lon = firstResult.x;
            const addr = firstResult.address_name.replace(
              "강원특별자치도 ",
              ""
            );

            props.clickedvalue(lat, lon, addr);
          }
        }

        // 검색 이벤트 핸들러
        const handleSearch = () => {
          const searchInput = document.getElementById("search");
          const keyword = searchInput.value;
          if (keyword.trim() !== "") {
            ps.keywordSearch(keyword, placesSearchCB);
          }
        };

        // 검색 버튼 클릭 이벤트
        const searchButton = document.getElementById("searchButton");
        if (searchButton) {
          searchButton.addEventListener("click", handleSearch);
        }

        // 엔터키 이벤트
        const searchInput = document.getElementById("search");
        if (searchInput) {
          searchInput.addEventListener("keypress", (e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              handleSearch();
            }
          });
        }
      });
    });
  }, []);

  return (
    <Box sx={{ position: "relative", width: "100%", height: "100%" }}>
      <div id={mapId} className="dsmap" />
      <Box
        sx={{
          position: "absolute",
          top: "10px",
          left: "10px",
          width: "50%",
          zIndex: 2,
          backgroundColor: "white",
          borderRadius: "4px",
          boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
        }}
      >
        <TextField
          id="search"
          placeholder="주소 또는 지명 검색"
          variant="outlined"
          size="small"
          fullWidth
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton id="searchButton" edge="end">
                  <SearchIcon />
                </IconButton>
              </InputAdornment>
            ),
          }}
          sx={{
            "& .MuiOutlinedInput-root": {
              borderRadius: "4px",
              backgroundColor: "white",
            },
          }}
        />
      </Box>
    </Box>
  );
}

export default KakaoMap;
